export function isCI() {
    if (isNode()) {
        return !!process.env.TEAMCITY_VERSION || !!process.env.BUILDKITE;
    }
    return false;
}
export function isNode() {
    // todo: need to add a browser test
    return typeof process !== 'undefined' && process.versions?.node != null;
}
//# sourceMappingURL=utils.js.map